import React from 'react';
import {
  Box,
  Grid
} from '@mui/material';
import TeamWorkloadChart from './TeamWorkloadChart';

interface TeamViewProps {
  epics: any[];
  aggregatedInsights?: any;
  loading?: boolean;
}

const TeamView: React.FC<TeamViewProps> = ({
  epics,
  aggregatedInsights,
  loading = false
}) => {
  // Aggregate workload data from all epics
  const aggregatedWorkload = new Map();

  epics.forEach(epic => {
    const workloadData = epic.insights?.team?.workloadDistribution || [];
    workloadData.forEach((member: any) => {
      if (aggregatedWorkload.has(member.assignee)) {
        const existing = aggregatedWorkload.get(member.assignee);
        existing.total += member.total;
        existing.completed += member.completed;
        existing.inProgress += member.inProgress;
        existing.completionRate = existing.total > 0 ? (existing.completed / existing.total) * 100 : 0;
      } else {
        aggregatedWorkload.set(member.assignee, { ...member });
      }
    });
  });

  const teamWorkloadData = Array.from(aggregatedWorkload.values());

  return (
    <Box>
      <Grid container spacing={3}>
        {/* Epic Team Member Workload Chart */}
        <Grid item xs={12}>
          <TeamWorkloadChart
            workloadData={teamWorkloadData}
            epics={epics}
            title="Epic Team Member Workload"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TeamView;
